import i18n from "i18next";
// Bindings for React: allow components to
// re-render when language changes.
import { initReactI18next } from "react-i18next"
import * as translatUS from './en-us.json';
import * as translatCA from './en-ca.json';
import * as translatGB from './en-gb.json';
import * as translatCZ from './cs-cz.json';
import * as translatDK from './da-dk.json';
import * as translatDE from './de-de.json';
import * as translatES from './es-es.json';
import * as translatFI from './fi-fi.json';
import * as translatFR from './fr-fr.json';
import * as translatIT from './it-it.json';
import * as translatJP from './ja-jp.json';
import * as translatKR from './ko-kr.json';
import * as translatNO from './nb-no.json';
import * as translatNL from './nl-nl.json';
import * as translatPL from './pl-pl.json';
import * as translatRU from './ru-ru.json';
import * as translatSE from './sv-se.json';
import * as translatAT from './de-at.json';
import * as translatIE from './en-eu.json';
import * as translatAU from './en-au.json';
import * as translatSG from './en-sg.json';
import * as translatVN from './vi-vn.json';
import * as translatTW from './zh-tw.json';
import * as translatMX from './es-mx.json';
import * as translatBR from './pt-br.json';
import * as translatHK from './en-hk.json';
import * as translatME from './en-me.json';
import * as translatPH from './en-ph.json';
import { config } from "../config";

/** URL segment (e.g. da-dk) → i18next resource key (e.g. dk). */
const PATH_LOCALE_TO_I18N_LNG: Record<string, string> = {
    'en-us': 'us',
    'en-ca': 'ca',
    'en-gb': 'gb',
    'en-eu': 'eu',
    'en-au': 'au',
    'en-sg': 'sg',
    'en-hk': 'hk',
    'en-me': 'me',
    'en-ph': 'ph',
    'ja-jp': 'jp',
    'ko-kr': 'kr',
    'zh-tw': 'tw',
    'de-de': 'de',
    'de-at': 'at',
    'fr-fr': 'fr',
    'es-es': 'es',
    'es-mx': 'mx',
    'it-it': 'it',
    'pt-br': 'br',
    'nl-nl': 'nl',
    'pl-pl': 'pl',
    'nb-no': 'no',
    'sv-se': 'se',
    'da-dk': 'dk',
    'fi-fi': 'fi',
    'cs-cz': 'cz',
    'ru-ru': 'ru',
    'vi-vn': 'vn',
};

export const DEFAULT_I18N_LNG = 'us';

/**
 * Maps the first pathname segment (e.g. /da-dk/cart → da-dk) to the i18n catalog key.
 * Falls back to US English when the segment is missing or unknown.
 */
export function getI18nLngFromPathname(pathname: string): string {
    const segment = pathname.split('/').filter(Boolean)[0]?.toLowerCase();
    if (!segment) return DEFAULT_I18N_LNG;
    return PATH_LOCALE_TO_I18N_LNG[segment] ?? DEFAULT_I18N_LNG;
}

const translations: Record<string, Record<string, string>> = {
    'us': { ...translatUS },
    'au': { ...translatAU },
    'sg': { ...translatSG },
    'ca': { ...translatCA },
    'gb': { ...translatGB },
    'cz': { ...translatCZ },
    'dk': { ...translatDK },
    'de': { ...translatDE },
    'es': { ...translatES },
    'fi': { ...translatFI },
    'fr': { ...translatFR },
    'eu': { ...translatIE },
    'it': { ...translatIT },
    'jp': { ...translatJP },
    'kr': { ...translatKR },
    'no': { ...translatNO },
    'nl': { ...translatNL },
    'pl': { ...translatPL },
    'ru': { ...translatRU },
    'se': { ...translatSE },
    'at': { ...translatAT },
    'tw': { ...translatTW },
    'vn': { ...translatVN },
    'mx': { ...translatMX },
    'br': { ...translatBR },
    'hk': { ...translatHK },
    'me': { ...translatME },
    'ph': { ...translatPH },
};

const initialLng = getI18nLngFromPathname(
    typeof window !== 'undefined' ? window.location.pathname : ''
);

const resources: Record<string, { translation: Record<string, string> }> = {};
for (const [lng, dict] of Object.entries(translations)) {
    resources[lng] = { translation: dict };
}

i18n
    .use(initReactI18next)
    .init({
        // Add React bindings as a plugin.
        // Initialize the i18next instance.
        // Config options

        // Specifies the default language (translateLocale) used
        // when a user visits our site for the first time.
        // We use English here, but feel free to use
        // whichever translateLocale you want.
        // Add React bindings as a plugin.
        // Initialize the i18next instance.
        // Config options

        // Specifies the default language (translateLocale) used
        // when a user visits our site for the first time.
        // We use English here, but feel free to use
        // whichever translateLocale you want.
        // Add React bindings as a plugin.
        // Initialize the i18next instance.
        // Config options

        // Specifies the default language (translateLocale) used
        // when a user visits our site for the first time.
        // We use English here, but feel free to use
        // whichever translateLocale you want.
        // Add React bindings as a plugin.
        // Initialize the i18next instance.
        // Config options

        // Specifies the default language (translateLocale) used
        // when a user visits our site for the first time.
        // We use English here, but feel free to use
        // whichever translateLocale you want.
        lng: initialLng,

        // Fallback translateLocale used when a translation is
        // missing in the active translateLocale. Again, use your
        // preferred translateLocale here.
        fallbackLng: DEFAULT_I18N_LNG,

        // Enables useful output in the browser’s
        // dev console.
        debug: config.debugTranslations,
        interpolation: {
            escapeValue: true,
        },
        resources,
    });

export default i18n;
